import { getStatuses } from '../../lib/statuses'
import { Key } from './Key'
import { useEffect } from 'react'
import { solution } from '../../lib/words'

type Props = {
  onChar: (value: string) => void
  onDelete: () => void
  onEnter: () => void
  guesses: string[]
  isRevealing?: boolean
}

export const Keyboard = ({
  onChar,
  onDelete,
  onEnter,
  guesses,
  isRevealing,
}: Props) => {
  const charStatuses = getStatuses(guesses, solution)

  const onClick = (value: string) => {
    if (value === 'ENTER') {
      onEnter()
    } else if (value === 'DELETE') {
      onDelete()
    } else {
      onChar(value)
    }
  }

  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      if (e.code === 'Enter') {
        onEnter()
      } else if (e.code === 'Backspace') {
        onDelete()
      } /*else {
        const key = localeAwareUpperCase(e.key)
        // TODO: check this test if the range works with non-english letters
        if (key.length === 1 && key >= 'A' && key <= 'Z') {
          onChar(key)
        }
      }*/
    }
    window.addEventListener('keyup', listener)
    return () => {
      window.removeEventListener('keyup', listener)
    }
  }, [onEnter, onDelete /*, onChar*/])

  const keyboardRows = [
    ['わ', 'ら', 'や', 'ま', 'は', 'な', 'た', 'さ', 'か', 'あ'],
    ['', 'り', '', 'み', 'ひ', 'に', 'ち', 'し', 'き', 'い'],
    ['', 'る', 'ゆ', 'む', 'ふ', 'ぬ', 'つ', 'す', 'く', 'う'],
    ['', 'れ', '', 'め', 'へ', 'ね', 'て', 'せ', 'け', 'え'],
    ['を', 'ろ', 'よ', 'も', 'ほ', 'の', 'と', 'そ', 'こ', 'お'],
    ['', '', 'ゃ', 'ぱ', 'ば', '', 'だ', 'ざ', 'が', 'ぁ'],
    ['ー', '', '', 'ぴ', 'び', '', 'ぢ', 'じ', 'ぎ', 'ぃ'],
    ['ゔ', '', 'ゅ', 'ぷ', 'ぶ', 'っ', 'づ', 'ず', 'ぐ', 'ぅ'],
    ['ん', '', '', 'ぺ', 'べ', '', 'で', 'ぜ', 'げ', 'ぇ'],
    ['', '', 'ょ', 'ぽ', 'ぼ', '', 'ど', 'ぞ', 'ご', 'ぉ'],
  ]

  return (
    <div>
      {keyboardRows.map((row, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          className={
            rowIndex === 4
              ? 'flex justify-center mb-2'
              : 'flex justify-center mb-1'
          }
        >
          {row.map((key, keyIndex) => (
            <Key
              value={key}
              key={`${rowIndex}-${keyIndex}`}
              onClick={onClick}
              status={charStatuses[key]}
              isRevealing={isRevealing}
            />
          ))}
        </div>
      ))}
    </div>
  )
}
